export const PASS_API_ROOT = process.env.VUE_APP_PASS_API_ROOT
export const PASS_DOWNLOAD_GOOGLE_API = PASS_API_ROOT + 'pass/google'
export const PASS_DOWNLOAD_APPLE_API = PASS_API_ROOT + 'pass/apple'
